import * as React from "react";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../../redux";
import { LanguageContext } from "../../../../../utilities/LocalizationModule";
import { expanderConstants } from "../../../redux/models/constants/expanders";
import ExpanderWithSubtitle from "../ExpanderWithSubtitle";
import { getSharedItems } from "../../../redux/modules/sharedItems";
import HomeItem from "./HomeItem";
import { ModeEnum } from "../../enums/modeEnum";
import { IStoreItem } from "../../../interfaces/IStoredItem";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { Spinner } from "@fluentui/react/lib/Spinner";
import { ExpanderStateEnum } from "../../enums/expanderStateEnum";
import { IDialogContentProps } from "@fluentui/react";
import generalModule from "../../../../../utilities/GeneralModule";

const mapDispatchToProps = {
  getSharedItems
};

const mapStateToProps = (state: RootState) => {
  return {
    shared: state.shared,
    accountId: state.user?.account?.accountId,
    showShared: state.user.settings.showShared,
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface SharedItemsProps extends PropsFromRedux {
  mode: ModeEnum;
  openFileOptions: (item: IStoreItem, isRecentList: boolean) => void;
  openFolderOptions: (item: IStoreItem, isRecentList: boolean) => void;
  showLicenseDialog: () => void;
  saveToOneDrive: (
    folderName: string,
    fromLocationItemCurrentDirectory?: IPageSettings,
    savingLocationDirectory?: string,
    locationBeforeSaving?: IPageSettings[]
  ) => Promise<void>;
  setLicenseMessageContent: (content: IDialogContentProps) => void;
}

const SharedItems: React.FunctionComponent<SharedItemsProps> = ({
  shared,
  mode,
  openFileOptions,
  openFolderOptions,
  showLicenseDialog,
  saveToOneDrive,
  getSharedItems,
  showShared,
  setLicenseMessageContent
}: SharedItemsProps) => {
  const canToggle: boolean = generalModule.isInConentMangerMode() ? false : true; //Side menu - toggle/button

  //funcs
  React.useEffect(() => {
    if (showShared && !shared.sharedItems) {
      getSharedItems(languageStrings);
    }
  }, [showShared]);

  //consts
  const languageStrings = React.useContext(LanguageContext);

  const items: JSX.Element[] = shared.sharedItems && shared.sharedItems.map((item, index) => {
    return (
      <HomeItem
        key={index}
        homeItem={item}
        mode={mode}
        isRecentList={true}
        openFileOptions={openFileOptions}
        openFolderOptions={openFolderOptions}
        showLicenseDialog={showLicenseDialog}
        saveToOneDrive={saveToOneDrive}
        setLicenseMessageContent={setLicenseMessageContent}
      />
    );
  });

  const emptyMessage: JSX.Element[] = items?.length === 0 && [<p className="xb-empty-location-message centerText" key="0">{languageStrings.SharedItemsShownHere}</p>];

  return (
    <ExpanderWithSubtitle
      iconName="Share"
      items={!canToggle ? [] : items?.length > 0 ? items : shared.isSharedItemsLoading ? [<Spinner key={0} />] : emptyMessage}
      title={languageStrings.Shared}
      expanderNameToToggle={expanderConstants.home.shared}
      hasShowMoreButton={true}
      canToggle={canToggle}
    />
  );
};

export default connector(SharedItems);
